module.exports = __webpack_public_path__ + "img/back-weituodanfenpai.fe0ba109.png";